module.exports = __webpack_public_path__ + "80b08a7a1fbb3b4b7973bbd51884a466.svg";